import flatpickr from "flatpickr";
import { German } from "flatpickr/dist/l10n/de.js";


class DatePicker {
    constructor($el){
        this.$el = $el;
        this.el = $el[0];
        this.init();
    }

    init = () => {
        this.flatpickr = flatpickr(this.el, {
            dateFormat: "Y-m-d",
            allowInput: true,
            disableMobile: true,
            locale: German,
        });
    }
}

export default DatePicker;
